import { useTranslation } from 'react-i18next';
import ODropDownMenu from '../../../../../UI/DropDownMenu/ODropDownMenu';
import { colors } from '../../../../../../../shared/colors';

const GridOptions = ({
  children,
  openFile,
  handleOpenDeleteDialog,
  downloadFile,
  editFile,
}) => {
  const { t, i18n } = useTranslation();
  const muiOptions = [
    {
      title: t('openFile'),
      subtitle: t('openFile'),
      id: 1,
      icon: 'fas fa-file',
      color: colors.EDIT,
      onClick: () => openFile(),
    },

    {
      title: t('downloadDocupent'),
      subtitle: t('downloadDocupent'),
      id: 3,
      icon: 'fas fa-file-download',
      color: colors.EDIT,
      onClick: () => downloadFile(),
    },
  ];
  // if (+localStorage.idFirme === 1) {
  //   muiOptions.push({
  //     title: t('buttons.delete'),
  //     subtitle: t('deleteData'),
  //     path: 'login',
  //     id: 2,
  //     icon: 'fas fa-trash',
  //     color: '#ff5552',
  //     onClick: () => handleOpenDeleteDialog(),
  //   });
  //   muiOptions.push({
  //     title: t('edit'),
  //     subtitle: t('edit'),
  //     id: 3,
  //     icon: 'fas fa-pen',
  //     color: colors.EDIT,
  //     onClick: () => editFile(),
  //   });
  // }
  return (
    <ODropDownMenu align="end" position="anchor" options={muiOptions}>
      {children}
    </ODropDownMenu>
  );
};

export default GridOptions;
